/**
 * @file: ErpSyncType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpSyncType {
  Automatic = 'automatic',
  Manual = 'manual',
}

export const ErpSyncTypeValueSet = new Set([
  ErpSyncType.Automatic,
  ErpSyncType.Manual,
]);
